module.exports = __webpack_public_path__ + "media/images/other/construction-223f943331731369e4916abefbee3e19.png";